/**
 * GTM dataLayer helper — pushes custom events for GA4 tags.
 * All events match the GTM container GTM-KJ2H5Z78 configuration.
 */

const push = (payload: Record<string, unknown>) => {
  const w = window as any;
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push(payload);
};

/** CTA "Réserver" clicks */
export const trackCtaReservation = (clickText: string, clickLocation: string) => {
  push({
    event: "cta_reservation_click",
    click_text: clickText,
    click_location: clickLocation,
    page_path: window.location.pathname,
  });
};

/** Contact form submission */
export const trackFormSubmission = (formType: string, sujet: string) => {
  push({
    event: "form_submission",
    form_type: formType,
    sujet,
  });
};

/** Email link clicks */
export const trackEmailClick = (emailAddress: string, clickLocation: string) => {
  push({
    event: "email_click",
    email_address: emailAddress,
    click_location: clickLocation,
  });
};

/** Phone call clicks */
export const trackPhoneCallClick = (phoneNumber: string, clickLocation: string) => {
  push({
    event: "phone_call_click",
    phone_number: phoneNumber,
    click_location: clickLocation,
  });
};

/** Social media link clicks */
export const trackSocialClick = (clickText: string, clickLocation: string, socialPlatform: string) => {
  push({
    event: "social_click",
    click_text: clickText,
    click_location: clickLocation,
    page_path: window.location.pathname,
    social_platform: socialPlatform,
  });
};

/** Google Maps itinerary clicks */
export const trackItineraryClick = (clickText: string, clickLocation: string) => {
  push({
    event: "itinerary_click",
    click_text: clickText,
    click_location: clickLocation,
    page_path: window.location.pathname,
  });
};

/** Booking location select on /reserver */
export const trackBookingLocationSelect = (locationName: string) => {
  push({
    event: "booking_location_select",
    location_name: locationName,
    page_path: window.location.pathname,
  });
};

/** FAQ accordion open */
export const trackFaqOpen = (question: string, faqLocation: string) => {
  push({
    event: "faq_open",
    faq_question: question,
    faq_location: faqLocation,
    page_path: window.location.pathname,
  });
};

/** Blog article click */
export const trackBlogArticleClick = (articleTitle: string, articleSlug: string) => {
  push({
    event: "blog_article_click",
    article_title: articleTitle,
    article_slug: articleSlug,
    page_path: window.location.pathname,
  });
};

/** Map popup phone click */
export const trackMapPhoneClick = (locationName: string, phoneNumber: string) => {
  push({
    event: "map_phone_click",
    location_name: locationName,
    phone_number: phoneNumber,
    page_path: window.location.pathname,
  });
};

/** Map popup reservation click */
export const trackMapReservationClick = (locationName: string) => {
  push({
    event: "map_reservation_click",
    location_name: locationName,
    page_path: window.location.pathname,
  });
};

/** Scroll depth tracking — fires at 25, 50, 75, 100% */
export const initScrollDepthTracking = () => {
  const thresholds = [25, 50, 75, 100];
  const fired = new Set<number>();

  const handler = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    if (docHeight <= 0) return;
    const percent = Math.round((scrollTop / docHeight) * 100);

    for (const t of thresholds) {
      if (percent >= t && !fired.has(t)) {
        fired.add(t);
        push({
          event: "scroll_depth",
          scroll_percentage: t,
          page_path: window.location.pathname,
        });
      }
    }
  };

  window.addEventListener("scroll", handler, { passive: true });
  return () => window.removeEventListener("scroll", handler);
};
